export const DEFAULT_SCENE = 'intraday:management';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;
export const NOTIFICATION_SIDEBAR_TAG = `${DEFAULT_SCENE}:notification-sidebar`;

export const INTRADAY_QUEUE_SELECT_TAG = `${DEFAULT_SCENE}:intraday-queue-select`;
export const GO_TO_SCHEDULE_BUTTON_TAG = `${DEFAULT_SCENE}:go-to-schedule:button`;
export const NOTIFICATIONS_TOGGLE_BUTTON_TAG = `${DEFAULT_SCENE}:notifications:button`;
export const DATA_AS_OF_TAG = `${DEFAULT_SCENE}:data-as-off:tag`;
export const REFRESH_DATA_BUTTON_TAG = `${DEFAULT_SCENE}:refresh-chart-data:button`;

// Notifications sidebar
export const ADD_NEW_NOTIFICATION_BUTTON_TAG = `${NOTIFICATION_SIDEBAR_TAG}:add-new-notification:button`;
export const CANCEL_NOTIFICATION_BUTTON_TAG = `${NOTIFICATION_SIDEBAR_TAG}:cancel-notification:button`;
export const SAVE_NOTIFICATION_BUTTON_TAG = `${NOTIFICATION_SIDEBAR_TAG}:save-notification:button`;

export const NOTICE_DEVIATION_TAG = `${NOTIFICATION_SIDEBAR_TAG}:deviation:notice`;
export const NOTICE_SLA_TAG = `${NOTIFICATION_SIDEBAR_TAG}:sla:notice`;

export const getNotificationActionTag = (actionType: 'actions' | 'edit' | 'delete' | 'duplicate') =>
  `${NOTIFICATION_SIDEBAR_TAG}:notification:${actionType}`;

export const getFieldsInputTag = (fieldName: string) => `${NOTIFICATION_SIDEBAR_TAG}:input-${fieldName}`;
export const getViewFieldsTag = (fieldName: string) => `${NOTIFICATION_SIDEBAR_TAG}:${fieldName}`;

// Charts
export const CHART_TOOLTIP_SERIES_TAG = `${DEFAULT_SCENE}:chart-tooltip-series`;
